import Bugsnag from "@bugsnag/js"
import BugsnagPluginReact from "@bugsnag/plugin-react"

export function setupBugsnag() {
    Bugsnag.start({
        apiKey: "141543692e86c71a8df8cde8e2cdbf6e",
        appType: "web",
        appVersion: process.env.REACT_APP_GITHUB_TAG,
        releaseStage: process.env.REACT_APP_STAGE,
        plugins: [new BugsnagPluginReact()],
    })
}
